export interface JSServiceActionParam {
  data?: unknown;
  actionCallId: string;
}

export interface JSServiceAction {
  actionId: string;
  handler: (param: JSServiceActionParam) => Promise<unknown>;
}

export enum JSServiceID {
  Mail = 'mail-js-service',
  Calendar = 'calendar-js-service',
  Docs = 'docs-js-service',
  Tasks = 'tasks-js-service',
  Clips = 'clips-js-service',
  Workflows = 'workflows-js-service',
  Drive = 'drive-js-service',
  RevenueAccelerator = 'revenue-acceleration-js-service',
  NewChat = 'new-chat-js-service',
  Contacts = 'contacts-js-service',
  Phone = 'phone-js-service',
  Scheduler = 'scheduler-js-service',
  Apps = 'apps-js-service',
  Workspaces = 'workspaces-js-service',
  Workvivo = 'workvivo-js-service',
  Notes = 'notes-js-service',
  Whiteboards = 'whiteboards-js-service',
  Surveys = 'surveys-js-service',
  GlobalSearch = 'global-search-js-service',
}

export interface JSService {
  serviceId: JSServiceID;
  actions: JSServiceAction[];
}

export type JSServiceRegistry = Map<string, JSService>;
